import { orchestrator } from 'satcheljs';
import {
    endCalendarFormPerfDatapoint,
    cancelCalendarFormPerfDatapoint,
} from '../actions/perfDatapointActions';
import getPerfDatapoint from '../selectors/getPerfDatapoint';
import { removeCalendarFormPerfDatapoint } from '../mutators/perfDatapointMutators';

orchestrator(endCalendarFormPerfDatapoint, actionMessage => {
    getPerfDatapoint(actionMessage.formId)?.end();
    removeCalendarFormPerfDatapoint(actionMessage.formId);
});

orchestrator(cancelCalendarFormPerfDatapoint, actionMessage => {
    getPerfDatapoint(actionMessage.formId)?.invalidate();
    removeCalendarFormPerfDatapoint(actionMessage.formId);
});
